module.exports = __webpack_public_path__ + "static/media/sf-forester_1.b3f970bc.webp";